import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Rola a página para o topo
  }, [location]); // Quando a localização (página) mudar, a função será chamada

  return null;
};

export default ScrollToTop;
